import React from 'react'
import Navbar from '../inc/Navbar'
import { Link } from "react-router-dom";
import KarimpurBranch from '../inc/KarimpurBranch';

import aparajitamam from "../images/Aparajita Mam karimpur.jpeg"
import Aparajiata_Karimpur from "../images/Aparajita Mam photo.jpeg";
import Grandopening_balajisaree from "../images/Opening Time.jpeg"
import aprajitamam_stage from "../images/Stage-Aparajita Mam.jpeg";

import shoppingtime from "../images/Shopping.jpeg";
import shoppingkarimpur from "../images/Sopping time karimpur.jpeg"
import Grandopening_dhaksaj from "../images/Opening_dhak.jpeg";
import madamwithBDOkarimpur from "../images/Madam.jpeg";

import aparijawithmlaickarimpur from  "../images/madam_aparajita.jpeg";
import mlawithTapanDebnath from "../images/MLA _ karimpur.jpeg"
import bestpgoto_Balajisaree from "../images/Best photo Balaji Saree.jpeg";
import Grandopening_invite from "../images/Balaji Saree Invited.jpeg";

import balajisaree_cashcounter from "../images/cash counter.jpeg";
import front from "../images/front_balajisaree.jpeg";
import frontshowroom from "../images/Front Balaji Saree.jpeg";
import Grandopening from "../images/Opening Time (2).jpeg"

import tapanbabu from "../images/Tapan Babu.jpeg";
import vlog from "../images/Interior.jpeg";


import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'


function KarimpurShowroom() {
  return (
    <div>
      <Navbar />

      <br />
      <br />


      <div className="album py-0">
        <div className="container ">
          <p>Balaji Saree Karimpur</p>
        </div>
      </div>


      <KarimpurBranch />
      <div className='ranaghatsaree'>
        <div className="album py-1">
          <div className="container mt-3">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Karimpur</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div className='karimpur_balajisaree'>
        <br />

        <div className="album py-1">
          <div className="container">
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingOne">
                  <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    BALAJI SAREE Karimpur Address
                  </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                  <div className="accordion-body">

                    <h5 style={{ color: "#AD0000" }}> Karimpur, New Bus Stand, Nadia, </h5>
                    <h5 style={{ color: "#AD0000" }}>Pin-741152 | West Bengal, India</h5>
                    <p style={{ color: "grey" }}><small>"Karimpur’s pride, right at New Bus Stand – here for you always!"
                    </small></p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="headingTwo">
                  <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    Contact Details
                  </button>
                </h2>
                <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                  <div className="accordion-body">
                    <p><a href='tel: 7718500550'><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone" viewBox="0 0 16 16">
  <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"/>
</svg> 7718500550</a> </p>
                  </div>
                </div>
              </div>
              <br />
            </div>
            <br />
          </div>



        </div>
      </div>
      <div className='karimpurbewbusstand'>
       
        <div className="album py-0">
          <div className="container">
            <br/>
             <h1 className='' style={{color:"#5C0000"}}><b>BALAJI SAREE </b>– Grand Opening at Karimpur</h1>
            <div className="row">

              <div className="col-md-6">
                <div className="d-flex justify-content-start align-items-center mb-2">
                  <div className="col-md-6 me-2 mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={Aparajiata_Karimpur} className="card-img-top" alt="Aparajiata_Karimpur" />


                        </Zoom>

                      </div>
                    </div>
                  </div>
                  <div className="col-md-6  mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={aparajitamam} className="card-img-top" alt="aparajita mam" />

                        </Zoom>

                      </div>
                    </div>

                  </div>

                </div>
              </div>
              <div className="col-md-6">
                <div className="d-flex justify-content-start align-items-center mb-2">
                  <div className="col-md-6 me-2 mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={aprajitamam_stage} className="card-img-top" alt="aprajitamam_stage" />

                        </Zoom>

                      </div>
                    </div>
                  </div>
                  <div className="col-md-6  mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={Grandopening_balajisaree} className="card-img-top" alt="Grandopening_balajisaree" />

                        </Zoom>

                      </div>

                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        
        <div className="album py-0">
          <div className="container">
            <div className="row">

              <div className="col-md-6">
                <div className="d-flex justify-content-start align-items-center mb-2">
                  <div className="col-md-6 me-2 mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={shoppingtime} className="card-img-top" alt="shoppingtime" />


                        </Zoom>

                      </div>
                    </div>
                  </div>
                  <div className="col-md-6  mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={shoppingkarimpur} className="card-img-top" alt="shoppingkarimpur Balaji Saree"/>

                        </Zoom>

                      </div>
                    </div>

                  </div>

                </div>
              </div>
              <div className="col-md-6">
                <div className="d-flex justify-content-start align-items-center mb-2">
                  <div className="col-md-6 me-2 mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={madamwithBDOkarimpur} className="card-img-top" alt="madamwithBDOkarimpur" />

                        </Zoom>

                      </div>
                    </div>
                  </div>
                  <div className="col-md-6  mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={Grandopening_dhaksaj} className="card-img-top" alt="Grandopening_balajisaree" />

                        </Zoom>

                      </div>

                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>


         <div className="album py-0">
          <div className="container">
            <div className="row">

              <div className="col-md-6">
                <div className="d-flex justify-content-start align-items-center mb-2">
                  <div className="col-md-6 me-2 mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={aparijawithmlaickarimpur} className="card-img-top" alt="aparijawithmlaickarimpur"/>


                        </Zoom>

                      </div>
                    </div>
                  </div>
                  <div className="col-md-6  mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={mlawithTapanDebnath} className="card-img-top" alt="mlawithTapanDebnath"/>

                        </Zoom>

                      </div>
                    </div>

                  </div>

                </div>
              </div>
              <div className="col-md-6">
                <div className="d-flex justify-content-start align-items-center mb-2">
                  <div className="col-md-6 me-2 mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={bestpgoto_Balajisaree} className="card-img-top" alt="bestpgoto_Balajisaree"/>

                        </Zoom>

                      </div>
                    </div>
                  </div>
                  <div className="col-md-6  mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={Grandopening_invite} className="card-img-top" alt="Grandopening_balajisaree" />

                        </Zoom>

                      </div>

                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

           <div className="album py-0">
          <div className="container">
            <div className="row">

              <div className="col-md-6">
                <div className="d-flex justify-content-start align-items-center mb-2">
                  <div className="col-md-6 me-2 mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={balajisaree_cashcounter} className="card-img-top" alt="balajisaree_cashcounter"/>


                        </Zoom>

                      </div>
                    </div>
                  </div>
                  <div className="col-md-6  mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={front} className="card-img-top" alt="balajisaree"/>

                        </Zoom>

                      </div>
                    </div>

                  </div>

                </div>
              </div>
              <div className="col-md-6">
                <div className="d-flex justify-content-start align-items-center mb-2">
                  <div className="col-md-6 me-2 mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={frontshowroom} className="card-img-top" alt="Balajisaree"/>

                        </Zoom>

                      </div>
                    </div>
                  </div>
                  <div className="col-md-6  mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={Grandopening} className="card-img-top" alt="balajisaree" />

                        </Zoom>

                      </div>

                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div className="album py-0">
          <div className="container">
            <div className="row">

              <div className="col-md-6">
                <div className="d-flex justify-content-start align-items-center mb-2">
                  <div className="col-md-6 me-2 mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={tapanbabu} className="card-img-top" alt="balajisaree"/>


                        </Zoom>

                      </div>
                    </div>
                  </div>
                  <div className="col-md-6  mt-3">
                    <div className='cardmotation'>
                      <div className="card">
                        <Zoom>
                          <img src={vlog} className="card-img-top" alt="balajisaree"/>

                        </Zoom>

                      </div>
                    </div>

                  </div>

                </div>
              </div>
          

            </div>
          </div>
        </div>
        <br/>
      </div>

    </div>
  )
}

export default KarimpurShowroom